var React = require('react');

function InlineSvg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M26 67c8.284 0 15-1.79 15-4s-6.716-4-15-4c-8.284 0-15 1.79-15 4s6.716 4 15 4Z","fill":"#000","opacity":"0.1","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.282 57.17c.12.036.24.071.361.105a7.33 7.33 0 0 1 4.35 3.712L26 63l1.007-2.014a7.33 7.33 0 0 1 4.349-3.711l.363-.105c.005 0 .01-.002.014-.003h-.002C39.984 54.702 46 47.054 46 38c0-11.046-8.954-20-20-20S6 26.954 6 38c0 9.054 6.016 16.703 14.269 19.167h-.002l.015.003Z","fill":"#FF5226","key":1}),React.createElement("path",{"d":"M26 31c-3.864 0-7 3.136-7 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7Z","fill":"#fff","key":2})]);
}

InlineSvg.defaultProps = {"viewBox":"0 0 52 70"};

module.exports = InlineSvg;

InlineSvg.default = InlineSvg;
